




























































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {IMedia, IMediaViewModel} from "@/_objects/IMedia";
import {download, search} from "@/_services/media.services";
import MediaApprove from "@/secure/MediaApprove.vue";
import MediaUpload from "@/secure/MediaUpload.vue";
import {ISearchResponse} from "@/_objects/ISearch";
import MediaEdit from "@/secure/MediaEdit.vue";
import MediaPreview from "@/secure/MediaPreview.vue";
@Component({
    components: {MediaApprove, MediaUpload, MediaEdit, MediaPreview},
})
export default class Media extends Vue {
    private static getBlankViewModel(): IMediaViewModel {
        return {
            id: "",
            isApproved: false,
            date: new Date(),
            publisher: "",
            url:  "",
            subid:  "",
            subid2:  "",
            description:  "",
            comment:  "",
            blockZovio: false,
            blockPEC: false,
            brandingBEM: "",
            brandingPub: "",
            pell38K: false,
            pell6K: false,
            pellYear: false,
            type: "",
            changeLog: new Array(),
        };
    }
    private loading = false;
    private media: ISearchResponse<IMedia> = { total: 0, items: []};
    private list: IMediaViewModel[] = [];
    private dialogApproveMedia: IMediaViewModel = Media.getBlankViewModel();
    private dialogApproveShow: boolean = false;
    private dialogUploadShow: boolean = false;
    private dialogEditMedia: IMediaViewModel = Media.getBlankViewModel();
    private dialogEditShow: boolean = false;
    private dialogPreviewUrl: string = "";
    private dialogPreviewType: string = "";
    private dialogPreviewShow: boolean = false;
    private isApproved: boolean = true;
    private search: string = "";
    private search2: string = "";
    private pagination: any = { sortBy: "date", descending: true, page: 1, rowsPerPage: 50};

    private headers = [
        { text: 'Id', value: 'id', sortable: false },
        { text: 'Date', value: 'date' },
        { text: 'Publisher', value: 'publisher.name' },
        { text: 'SubId', value: 'subid' },
        { text: 'SubId 2', value: 'subid2' },
        { text: 'Url', value: 'url', sortable: false },
        { text: 'Tags', value: 'tags', sortable: false },
        { text: 'Approved', value: 'dateUnapproved', sortable: true },
        { text: '', value: '', sortable: false },
    ];

    private async reload() {
        const sortBy = (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
        this.loading = true;
        try {
            this.media = await search({
                limit: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                isApproved: this.isApproved,
                sortBy,
                search: this.search,
                search2: this.search2,
            });
            this.list = this.media.items.map((mediaItem) => {
                return {
                    id: mediaItem.id,
                    isApproved: mediaItem.isApproved,
                    date: mediaItem.date,
                    dateUnapproved: mediaItem.dateUnapproved,
                    publisher: mediaItem.publisher.name,
                    url: mediaItem.url,
                    subid: mediaItem.subid,
                    subid2: mediaItem.subid2,
                    comment: mediaItem.comment,
                    description: mediaItem.description,
                    blockZovio: mediaItem.blockZovio,
                    blockPEC: mediaItem.blockPEC,
                    brandingBEM: mediaItem.brandingBEM,
                    brandingPub: mediaItem.brandingPub,
                    pell38K: mediaItem.pell38K,
                    pell6K: mediaItem.pell6K,
                    pellYear: mediaItem.pellYear,
                    type: mediaItem.type,
                    changeLog: mediaItem.changeLog,
                };
            });
        } catch (err) {
            // Do nothing
            this.loading = false;
        }

        this.loading = false;
    }
    private csv() {
        const sortBy = (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
        download({
            isApproved: this.isApproved,
            sortBy,
            search: this.search,
            search2: this.search2,
        });
    }
    private async created() {
        await this.reload();
    }

    private toggleApproved(media: IMediaViewModel) {
        this.dialogApproveMedia = JSON.parse(JSON.stringify(media));
        this.dialogApproveShow = true;
    }

    private toggleUpload() {
        this.dialogUploadShow = true;
    }

    private edit(media: IMediaViewModel) {
        this.dialogEditMedia = JSON.parse(JSON.stringify(media));
        this.dialogEditShow = true;
    }

    private preview(url: string) {
        this.dialogPreviewUrl = url;
        this.dialogPreviewShow = true;
        this.dialogPreviewType = this.canPreview(url);
    }

    private canPreview(url: string) {
        let ext: string = "";
        if (url) {
            const pop = url.split('.').pop();
            ext = pop ? pop.toLowerCase() : "";
        }
        switch (ext) {
            case "doc":
            case "docx":
                return "OFFICE";
            default:
                return "";
        }
    }

    @Watch('isApproved')
    private onApprovedChanged() {
        this.pagination.page = 1;
        this.reload();
    }

    @Watch('pagination', {deep: true})
    private async onPaginationChanged(newValue: any, oldValue: any) {
        if (newValue.sortBy !== oldValue.sortBy || newValue.descending !== oldValue.descending || newValue.rowsPerPage !== oldValue.rowsPerPage) {
            await this.reload();
        } else if (newValue.page !== oldValue.page) {
            await this.reload();
        }
     }
}
